import { Outlet } from 'react-router';
import { MinimizedHeader } from '../minimized-header/minimized-header';
import { SideNavigation } from '../side-nav/side-nav';
import './calculator-wrapper-.css';
import { Footer } from '../footer/footer';

export const CalculatorWrapper = () => {
	return (
		<div className='w-full box-border bg-canvas min-h-screen flex flex-col'>
			<div className='w-full'>
				<MinimizedHeader></MinimizedHeader>
			</div>
			<div className='w-full flex flex-1'>
				<div className='min-w-[24%] max-w-[26%] border-r border-line sm:hidden xs:hidden'>
					<SideNavigation></SideNavigation>
				</div>
				<div className='w-full px-[4rem] py-[3rem] sm:px-[1.6rem] xs:px-[1.6rem]'>
					<Outlet></Outlet>
				</div>
			</div>
			<div className='w-full'>
				<Footer></Footer>
			</div>
		</div>
	);
};
